<div class="third-person-partial-container container">
  <div>
    <h1>Заказчик перевозки</h1>

    <el-form-item>
      <el-form-item label="Заказчик грузоперевозки" prop="thirdPerson.cargoTransportationCustomer">
        <el-radio-group class="font-size_el-radio-button__inner" v-model="dataForm.thirdPerson.cargoTransportationCustomer" @change="clearThirdPerson">
          <el-radio-button v-for="option in optionsWhoPays" :key="option.value" :label="option.label" />
        </el-radio-group>
      </el-form-item>
    </el-form-item>

    <template v-if="dataForm.thirdPerson.cargoTransportationCustomer === 'Третье лицо'">
      <el-form-item prop="thirdPerson.typeThirdPerson">
        <el-switch v-model="dataForm.thirdPerson.typeThirdPerson" inactive-text="Физ.лицо" active-text="Юр.лицо" />
      </el-form-item>

      <el-form-item v-if="dataForm.thirdPerson.typeThirdPerson" label="ИНН заказчика" prop="thirdPerson.innThirdPerson">
        <el-input type="text" autocomplete="on" v-model="dataForm.thirdPerson.innThirdPerson" v-mask="INN_MASK" @change="getNameOrganization('thirdPerson', dataForm.thirdPerson.innThirdPerson)" />
      </el-form-item>
      <el-form-item v-if="dataForm.thirdPerson.typeThirdPerson" label="Наименование организации" prop="thirdPerson.name">
        <el-input type="text" autocomplete="on" v-model="dataForm.thirdPerson.name" />
      </el-form-item>

      <el-form-item class="align-items--flex-end_el-form-item__content">
        <el-col :span="11">
          <el-form-item label="Телефон заказчика" prop="thirdPerson.phoneThirdPerson">
            <el-input v-model="dataForm.thirdPerson.phoneThirdPerson" v-mask="PHONE_MASK" type="tel" :formatter="(value) => `${value}`.replace(/\(89/g, '9')" :placeholder="PHONE_PLACEHOLDER" />
          </el-form-item>
        </el-col>
        <el-col :span="2" />
        <el-col :span="11">
          <el-form-item type="email" label="Эл. почта" prop="thirdPerson.emailThirdPerson" :required="dataForm.thirdPerson.typeThirdPerson">
            <el-input type="email" autocomplete="email" v-model="dataForm.thirdPerson.emailThirdPerson" />
          </el-form-item>
        </el-col>
      </el-form-item>

      <el-form-item label="ФИО заказчика" v-if="!dataForm.thirdPerson.typeThirdPerson" class="margin-bottom--30-p">
        <el-col :span="7">
          <el-form-item prop="thirdPerson.surnameThirdPerson">
            <el-input
              placeholder="Фамилия"
              type="text"
              autocomplete="family-name"
              v-model="dataForm.thirdPerson.surnameThirdPerson"
              @keyup="dataForm.thirdPerson.surnameThirdPerson = limitInput(dataForm.thirdPerson.surnameThirdPerson)"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1" class="multiplication"></el-col>
        <el-col :span="7">
          <el-form-item prop="thirdPerson.firstNameThirdPerson">
            <el-input
              placeholder="Имя"
              type="text"
              autocomplete="given-name"
              v-model="dataForm.thirdPerson.firstNameThirdPerson"
              @keyup="dataForm.thirdPerson.firstNameThirdPerson = limitInput(dataForm.thirdPerson.firstNameThirdPerson)"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1" class="multiplication"></el-col>
        <el-col :span="7">
          <el-form-item prop="thirdPerson.secondNameThirdPerson">
            <el-input
              placeholder="Отчество"
              type="text"
              autocomplete="additional-name"
              v-model="dataForm.thirdPerson.secondNameThirdPerson"
              @keyup="dataForm.thirdPerson.secondNameThirdPerson = limitInput(dataForm.thirdPerson.secondNameThirdPerson)"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
    </template>
  </div>

  <div class="bord_button">
    <el-form-item>
      <!-- <router-link to=
      
      -->
    </el-form-item>
    <el-form-item>
      <el-button
        class="button_send"
        type="primary"
        @click="$emit('click-button-next', [...getArrayOfRules(dataForm.sender, 'sender'), ...getArrayOfRules(dataForm.consignee, 'consignee'), ...getArrayOfRules(dataForm.thirdPerson, 'thirdPerson')])"
      >
        Далее
      </el-button>
    </el-form-item>
  </div>
</div>
